import {createSelector} from 'reselect';
import get from 'lodash/get';

const statisticsDataSelector = state => state.statistics;

export const getStatisticsData = createSelector(
  [statisticsDataSelector],
  statisticsData => get(statisticsData, 'statisticsData', {})
);
